import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { LoginGuard } from '../guards/login.guard';

const routes: Routes = [
	{
		path: 'login',
		loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule),
		canLoad: [LoginGuard]
	},
	{
		path: 'register',
		loadChildren: () => import('./register/register.module').then(m => m.RegisterPageModule),
		canLoad: [LoginGuard]
	},
	{
		path: 'tabs',
		loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule),
		canLoad: [AuthGuard]
	},
	{
		path: 'activities',
		loadChildren: () => import('./activities/activities.module').then(m => m.ActivitiesPageModule)
	},
	{
		path: '',
		redirectTo: '/login',
		pathMatch: 'full'
	},
  {
	path: 'app-update',
	loadChildren: () => import('./app-update/app-update.module').then( m => m.AppUpdatePageModule)
  },
  {
    path: 'consent',
    loadChildren: () => import('./consent/consent.module').then( m => m.ConsentPageModule)
  },


];
@NgModule({
	imports: [
		RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }
